import { Link } from 'react-router-dom';
import MovieCard from '@/components/feature/MovieCard';
import type { Movie } from '@/mocks/content';

interface MovieSectionProps {
  title: string;
  subtitle?: string;
  linkTo?: string;
  movies: Movie[];
}

export default function MovieSection({ title, subtitle, linkTo, movies }: MovieSectionProps) {
  return (
    <section className="w-full max-w-[1400px] mx-auto px-4 md:px-6 py-8">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">{title}</h2>
          {subtitle && <p className="text-sm text-foreground-500 mt-1">{subtitle}</p>}
        </div>
        {linkTo && (
          <Link
            to={linkTo}
            className="flex items-center gap-1 text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-s-line" />
          </Link>
        )}
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5" data-product-shop="true">
        {movies.map((movie) => (
          <MovieCard key={movie.id} movie={movie} />
        ))}
      </div>
    </section>
  );
}